<template>
  <div class="sidebar">
    <div class="sidebar__layout">
      <p class="title">Règles de validation des challenges</p>
      <p>
        Seules les participations avec la photo du trophée sur l’écran de votre
        console accompagnée de votre pseudo WAP et PSN ID écrits à la main sur
        un papier seront validées. Exemple ci-dessous :
      </p>
      <img
        src="/img/screen_challenge.jpg"
        alt="exemple d'une photo pour valider un challenge"
      />
      <p>
        Le pseudo WAP et le PSN Id doivent correspondre à ceux renseignés sur
        votre profil WAP.
      </p>
      <p>Un seul compte par personne est admis dans les challenges.</p>
      <p>
        <strong>
          Les challenges sont validés au fur et à mesure du mois. Soyez patients
          😉
        </strong>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sidebar {
  @media (min-width: 992px) {
    flex: 1 1 auto;
    max-width: 300px;
  }

  &__layout {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    overflow-y: scroll;
    color: #fff;
    background-color: $blue;

    @media (max-width: 992px) {
      padding: 2rem;
    }

    @media (min-width: 992px) {
      padding: 5rem;
    }

    .title {
      font-size: 2.2rem;
      line-height: 1.2;
    }

    p {
      margin-bottom: 2rem;
      line-height: 1.7;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    img {
      width: 100%;
      margin-bottom: 2rem;
    }

    strong {
      font-size: 1.6rem;
    }
  }
}
</style>
